export const GET_PROGRAM_TYPES = 'GET_PROGRAM_TYPES';
export const GET_PROGRAM_TYPES_SUCCESS = `${GET_PROGRAM_TYPES}_SUCCESS`;
